import { _join } from 'libs/lodash';
import { IDetailRequestAction } from 'utils/strings/requestActions';

export const getTaskKey = (detailRequestAction: IDetailRequestAction, id: string): string => {
  const wordsList: string[] = [detailRequestAction, id];

  return _join(wordsList, '_');
};
